import { call, put, takeLatest } from 'redux-saga/effects';
import HeroSchedulesAPI from 'api-services/HeroSchedulesApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { FETCH_SCHEDULES, EDIT_SCHEDULES } from './actionTypes';
import { doneFetchingSchedules, errorFetchingSchedules, editSchedulesDone, editSchedulesError } from './actionCreators';
import { logout } from '../auth/actionCreators';
// get schedules
export function* getSchedules(constAccessParams) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroSchedulesAPI.getSchedules, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(doneFetchingSchedules(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorFetchingSchedules(result.msg));
    }
}
export function* watchSchedulesCalls(constAccessParams) {
    yield takeLatest(FETCH_SCHEDULES, getSchedules, constAccessParams);
}
// edit schedules
export function* editSchedules(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroSchedulesAPI.editSchedules, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(editSchedulesDone({ isAutoApplied: result.data.auto_apply }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(editSchedulesError(result.msg));
    }
}
export function* watchEditSchedulesCalls(constAccessParams) {
    yield takeLatest(EDIT_SCHEDULES, editSchedules, constAccessParams);
}
//# sourceMappingURL=saga.js.map